import JobSummaryBanner from './JobSummaryBanner'

export default JobSummaryBanner
